export var ApiPushExecutionStatus;
(function (ApiPushExecutionStatus) {
    ApiPushExecutionStatus["Success"] = "success";
    ApiPushExecutionStatus["Running"] = "running";
    ApiPushExecutionStatus["Failure"] = "failure";
})(ApiPushExecutionStatus || (ApiPushExecutionStatus = {}));
